<script setup>
import { ChevronDownIcon } from "lucide-vue-next";
import { computed } from "vue";

import TeamProfile from "@/Layouts/Partials/TeamProfile.vue";
import UserProfile from "@/Layouts/Partials/UserProfile.vue";

import ApplicationLogo from "@/Components/ApplicationWLogo.vue";

import { Link, usePage } from "@inertiajs/vue3";

defineProps({
  crumbs: {
    type: Array,
    required: false,
    default: () => []
  },
  expander: {
    type: Boolean,
    default: true
  }
});

const page = usePage();

const team = computed(() => page.props.team);
const campaign = computed(() => page.props.campaign);
</script>

<template>
  <div
    class="app-mobile-header-spacer pt-14 md:hidden"
    :style="{ background: campaign?.cover_photo_url ? '' : campaign?.settings.background_color, color: campaign?.settings.color }"
  ></div>

  <nav class="app-mobile-header fixed inset-x-0 top-0 z-40 min-h-14 w-full bg-white py-2 shadow-soft transition dark:bg-deep-900 md:hidden">
    <div class="header-container relative flex w-full px-4 print:hidden">
      <div class="flex h-10 w-full items-center justify-between">
        <slot v-if="$slots.left" name="left" />
        <div v-else class="w-20 flex-none">
          <Link :href="route('teams.show', team)">
            <ApplicationLogo class="h-10 w-12" />
          </Link>
        </div>

        <slot v-if="$slots.center" name="center" />
        <TeamProfile v-else panel-class="inset-x-0 rounded-t-none mt-4" panel-content-class="w-full">
          <template #default="{ open }">
            <div class="flex w-full items-center justify-center rounded-xl px-1.5 outline-none ring-0 transition duration-300 focus:outline-none">
              <div class="flex flex-1 items-center justify-end text-900">
                <h1 class="expanded w-28 truncate text-sm+ font-bold">{{ team.campaign.name }}</h1>
                <ChevronDownIcon class="expanded h-4 w-4 transition" :class="[open ? '-rotate-90' : '']" />
              </div>
            </div>
          </template>
        </TeamProfile>

        <slot v-if="$slots.right" name="right" />
        <div v-else class="flex w-20 flex-none items-center justify-end gap-x-2">
          <div class="w-8">
            <UserProfile panel-class="inset-x-0 mt-1.5 rounded-t-none" panel-content-class="w-full">
              <template #default="{ user }">
                <button class="p-px">
                  <img class="h-7 w-7 flex-none rounded-full ring-1 bg-50" :src="user.profile_photo_url" alt="user profile image" />
                </button>
              </template>
            </UserProfile>
          </div>
          <!--end::user-profile-or-login-->
        </div>
      </div>
    </div>
  </nav>
</template>
